// import React, { useState, useEffect } from 'react';
// import { Link, useNavigate } from 'react-router-dom';
// import { Helmet } from 'react-helmet-async';
// import { motion, useInView } from 'framer-motion';
// import { useRef } from 'react';
// import { 
//   ArrowRight, Award, Target, Users, BookOpen, ChevronRight, 
//   User, Briefcase, Mail, Phone, Building, Star, Shield, 
//   GraduationCap, Clock, CheckCircle, UserCircle, FileText,
//   MapPin, Calendar, Sparkles, BadgeCheck
// } from 'lucide-react';
// import Navbar from "../Navbar/Navbar";
// import Footer from "../Footer/Footer";
// import './Mentor.css';

// const site = 'https://your-platform.com';

// // Function to generate slug from full name
// const generateSlug = (fullName) => {
//   return fullName
//     .toLowerCase()
//     .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
//     .replace(/\s+/g, '-') // Replace spaces with hyphens
//     .replace(/-+/g, '-'); // Remove duplicate hyphens
// };

// const fadeUp = {
//   hidden: { opacity: 0, y: 32 },
//   visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
// };

// const stagger = {
//   hidden: {},
//   visible: { transition: { staggerChildren: 0.1 } },
// };

// function FadeUp({ children, delay = 0, className = '' }) {
//   const ref = useRef(null);
//   const inView = useInView(ref, { once: true, margin: '-60px' });
//   return (
//     <motion.div
//       ref={ref}
//       initial={{ opacity: 0, y: 28 }}
//       animate={inView ? { opacity: 1, y: 0 } : {}}
//       transition={{ duration: 0.55, delay, ease: 'easeOut' }}
//       className={className}
//     >
//       {children}
//     </motion.div>
//   );
// }

// export default function MentorPage() {
//   const url = `${site}/mentor`;
//   const navigate = useNavigate();
//   const [mentors, setMentors] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   // Fetch mentors from API
//   useEffect(() => {
//     const fetchMentors = async () => {
//       try {
//         const response = await fetch('http://145.79.0.94:8000/api/mentor/mentors/');
//         const data = await response.json();
//         if (data.status && data.data) {
//           // Filter only active mentors
//           const activeMentors = data.data.filter(mentor => mentor.mentorship_status === 'active');
//           setMentors(activeMentors);
//         } else {
//           setError('Failed to fetch mentors');
//         }
//       } catch (err) {
//         setError('Error connecting to server');
//         console.error('Error fetching mentors:', err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchMentors();
//   }, []);

//   // Handle view profile click
//   const handleViewProfile = (mentor) => {
//     const slug = generateSlug(mentor.full_name);
//     navigate(`/mentor/${slug}`);
//   };

//   const jsonLd = {
//     '@context': 'https://schema.org',
//     '@type': 'WebPage',
//     '@id': `${url}#webpage`,
//     name: 'Mentorship Program',
//     url,
//     isPartOf: { '@id': `${site}/#website` },
//     about: { '@id': `${site}/#organization` },
//   };

//   const mentorData = {
//     hero: {
//       eyebrow: 'MENTORSHIP PROGRAM',
//       headline: 'Mentorship Program',
//       subheadline: 'Connect with experienced mentors who guide you through your professional development journey.',
//     },
//     story: {
//       pull_quote: 'The best professionals are built through a combination of technical knowledge, hands-on experience, and guidance from those who have walked the path before them.',
//       paragraphs: [
//         'Our mentorship program connects aspiring professionals with experienced mentors who have decades of field experience. We believe that the most effective way to develop competence is through a structured program that combines theoretical learning with practical, real-world application.',
//         'The program is designed to bridge the gap between learning and field readiness, ensuring that participants develop not only technical knowledge but also the professional judgment and confidence needed to excel.',
//         'Mentors in our program are industry experts with extensive international experience across a range of projects. They bring practical insights, real-world case studies, and industry connections that accelerate professional development.'
//       ],
//     },
//     cta: {
//       headline: 'Ready to Start Your Mentorship Journey?',
//       subheadline: 'Connect with our expert mentors and accelerate your career growth.',
//       cta_primary: 'Apply Now',
//       cta_secondary: 'Learn More'
//     }
//   };

//   return (
//     <>
//       <Helmet>
//         <title>Mentorship Program</title>
//         <meta name="description" content="Connect with experienced mentors who guide you through your professional development journey." />
//         <link rel="canonical" href={url} />
//         <meta property="og:title" content="Mentorship Program" />
//         <meta property="og:description" content="Expert mentorship for aspiring professionals. Build your career with guidance from certified professionals." />
//         <meta property="og:url" content={url} />
//         <meta property="og:type" content="website" />
//         <meta name="twitter:card" content="summary_large_image" />
//         <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
//       </Helmet>

//       <Navbar />

//       <main>
//         {/* ── HERO ── */}
//         <section className="mentor-hero">
//           <div className="mentor-hero-top-line" />
//           <div className="mentor-hero-grid-overlay" />
//           <div className="container">
//             <motion.div
//               initial={{ opacity: 0, y: 32 }}
//               animate={{ opacity: 1, y: 0 }}
//               transition={{ duration: 0.7, ease: 'easeOut' }}
//               className="mentor-hero-content"
//             >
//               <div className="mentor-hero-eyebrow">
//                 <div className="mentor-hero-line" />
//                 <span>{mentorData.hero.eyebrow}</span>
//               </div>
//               <h1 className="mentor-hero-title">{mentorData.hero.headline}</h1>
//               <p className="mentor-hero-subtitle">{mentorData.hero.subheadline}</p>
//             </motion.div>
//           </div>
//         </section>

//         {/* ── STORY ── */}
//         <section className="mentor-story-section">
//           <div className="container">
//             <div className="mentor-story-grid">
//               <motion.div
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true }}
//                 variants={stagger}
//                 className="mentor-story-quote"
//               >
//                 <motion.div variants={fadeUp} className="mentor-story-eyebrow">
//                   <div className="mentor-hero-line" />
//                   <span>Why Mentorship Matters</span>
//                 </motion.div>
//                 <motion.blockquote variants={fadeUp} className="mentor-story-blockquote">
//                   <span className="mentor-story-quote-mark">"</span>
//                   <p className="mentor-story-quote-text">
//                     {mentorData.story.pull_quote}
//                   </p>
//                 </motion.blockquote>
//               </motion.div>

//               <motion.div
//                 initial="hidden"
//                 whileInView="visible"
//                 viewport={{ once: true }}
//                 variants={stagger}
//                 className="mentor-story-paragraphs"
//               >
//                 {mentorData.story.paragraphs.map((para, i) => (
//                   <motion.p key={i} variants={fadeUp} className="mentor-story-text">
//                     {para}
//                   </motion.p>
//                 ))}
//               </motion.div>
//             </div>
//           </div>
//         </section>

//         {/* ── MENTORS SECTION ── */}
//         <section className="mentors-section">
//           <div className="container">
//             <FadeUp className="mentors-header">
//               <div className="mentors-eyebrow">
//                 <div className="mentor-hero-line" />
//                 <span>Our Mentors</span>
//                 <div className="mentor-hero-line" />
//               </div>
//               <h2>Meet Our Expert Mentors</h2>
//               <p>Connect with experienced professionals who are passionate about guiding the next generation.</p>
//             </FadeUp>

//             {loading ? (
//               <div className="mentors-loading">
//                 <div className="mentors-loading-spinner"></div>
//                 <p>Loading mentors...</p>
//               </div>
//             ) : error ? (
//               <div className="mentors-error">
//                 <p>{error}</p>
//               </div>
//             ) : mentors.length === 0 ? (
//               <div className="mentors-empty">
//                 <p>No active mentors available at the moment. Please check back later.</p>
//               </div>
//             ) : (
//               <div className="mentors-list">
//                 {mentors.map((mentor, index) => (
//                   <FadeUp key={mentor.id} delay={index * 0.05}>
//                     <div className="mentor-card-horizontal">
//                       {/* Profile Section - 30% */}
//                       <div className="mentor-card-profile">
//                         <div className="mentor-avatar-large">
//                           {mentor.profile_picture ? (
//                             <img src={mentor.profile_picture} alt={mentor.full_name} />
//                           ) : (
//                             <div className="mentor-avatar-placeholder-large">
//                               {mentor.full_name?.charAt(0) || 'M'}
//                             </div>
//                           )}
//                         </div>
//                         <div className="mentor-profile-badge">
//                           <BadgeCheck size={14} />
//                           <span>Verified Mentor</span>
//                         </div>
//                         <div className="mentor-profile-status">
//                           <span className="status-dot active"></span>
//                           Active
//                         </div>
//                         <div className="mentor-profile-stats">
//                           <div className="profile-stat">
//                             <Users size={14} />
//                             <span>{mentor.current_trainees || 0}</span>
//                           </div>
//                           <div className="profile-stat">
//                             <Star size={14} />
//                             <span>{mentor.years_of_experience || 0}+ yrs</span>
//                           </div>
//                         </div>
//                       </div>

//                       {/* Details Section - 70% */}
//                       <div className="mentor-card-details">
//                         <div className="mentor-details-header">
//                           <div>
//                             <h3 className="mentor-name-large">{mentor.full_name}</h3>
//                             <p className="mentor-title">{mentor.current_company || 'Independent Mentor'}</p>
//                           </div>
//                           <button 
//                             onClick={() => handleViewProfile(mentor)}
//                             className="mentor-view-btn"
//                           >
//                             View Profile <ArrowRight size={14} />
//                           </button>
//                         </div>

//                         <div className="mentor-details-grid">
//                           <div className="mentor-detail-item">
//                             <Mail size={14} />
//                             <span>{mentor.email}</span>
//                           </div>
//                           {mentor.phone_number && (
//                             <div className="mentor-detail-item">
//                               <Phone size={14} />
//                               <span>{mentor.phone_number}</span>
//                             </div>
//                           )}
//                           <div className="mentor-detail-item">
//                             <Briefcase size={14} />
//                             <span>{mentor.years_of_experience || 0} years experience</span>
//                           </div>
//                           <div className="mentor-detail-item">
//                             <Users size={14} />
//                             <span>Max {mentor.max_trainees || 'Unlimited'} trainees</span>
//                           </div>
//                         </div>

//                         {mentor.specializations && mentor.specializations.length > 0 && (
//                           <div className="mentor-specializations-section">
//                             <span className="mentor-section-label">Specializations</span>
//                             <div className="mentor-tags-list">
//                               {mentor.specializations.map((spec, idx) => (
//                                 <span key={idx} className="mentor-tag-item">
//                                   {spec.department_name}
//                                 </span>
//                               ))}
//                             </div>
//                           </div>
//                         )}

//                         {mentor.certifications && mentor.certifications.length > 0 && (
//                           <div className="mentor-certifications-section">
//                             <span className="mentor-section-label">Certifications</span>
//                             <div className="mentor-tags-list">
//                               {mentor.certifications.slice(0, 4).map((cert, idx) => (
//                                 <span key={idx} className="mentor-tag-item cert">
//                                   {cert.certification_name || cert.certification_type_display}
//                                 </span>
//                               ))}
//                               {mentor.certifications.length > 4 && (
//                                 <span className="mentor-tag-item more">
//                                   +{mentor.certifications.length - 4} more
//                                 </span>
//                               )}
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                   </FadeUp>
//                 ))}
//               </div>
//             )}
//           </div>
//         </section>

//         {/* ── CTA ── */}
//         <section className="mentor-cta">
//           <div className="mentor-cta-top-line" />
//           <div className="container">
//             <FadeUp>
//               <div className="mentor-cta-content">
//                 <h2>{mentorData.cta.headline}</h2>
//                 <p>{mentorData.cta.subheadline}</p>
//                 <div className="mentor-cta-buttons">
//                   <Link to="/contact" className="mentor-cta-primary">
//                     {mentorData.cta.cta_primary} <ArrowRight size={16} />
//                   </Link>
//                   <Link to="/platform" className="mentor-cta-secondary">
//                     {mentorData.cta.cta_secondary} <ChevronRight size={16} />
//                   </Link>
//                 </div>
//               </div>
//             </FadeUp>
//           </div>
//         </section>
//       </main>

//       <Footer />
//     </>
//   );
// }



// Mentor.jsx
import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';
import { 
  ArrowRight, Award, Target, Users, BookOpen, ChevronRight, 
  User, Briefcase, Mail, Phone, Building, Star, Shield, 
  GraduationCap, Clock, CheckCircle, UserCircle, FileText,
  MapPin, Calendar, Sparkles, BadgeCheck, User as UserIcon
} from 'lucide-react';
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import './Mentor.css';

const site = 'https://your-platform.com';

// Function to generate slug from full name
const generateSlug = (fullName) => {
  return fullName
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .replace(/-+/g, '-'); // Remove duplicate hyphens
};

// Function to get image URL with fallback
const getImageUrl = (profilePicture) => {
  if (!profilePicture) return null;
  
  // If it's a full URL, use it as is
  if (profilePicture.startsWith('http://') || profilePicture.startsWith('https://')) {
    return profilePicture;
  }
  
  // If it's a relative path, prepend the API base URL
  if (profilePicture.startsWith('/')) {
    return `http://145.79.0.94:8000${profilePicture}`;
  }
  
  // If it's a relative path without leading slash
  return `http://145.79.0.94:8000/${profilePicture}`;
};

const fadeUp = {
  hidden: { opacity: 0, y: 32 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

const stagger = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1 } },
};

function FadeUp({ children, delay = 0, className = '' }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, margin: '-60px' });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 28 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.55, delay, ease: 'easeOut' }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export default function MentorPage() {
  const url = `${site}/mentor`;
  const navigate = useNavigate();
  const [mentors, setMentors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch mentors from API
  useEffect(() => {
    const fetchMentors = async () => {
      try {
        const response = await fetch('http://145.79.0.94:8000/api/mentor/mentors/');
        const data = await response.json();
        if (data.status && data.data) {
          // Filter only active mentors
          const activeMentors = data.data.filter(mentor => mentor.mentorship_status === 'active');
          setMentors(activeMentors);
        } else {
          setError('Failed to fetch mentors');
        }
      } catch (err) {
        setError('Error connecting to server');
        console.error('Error fetching mentors:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchMentors();
  }, []);

  // Handle view profile click
  const handleViewProfile = (mentor) => {
    const slug = generateSlug(mentor.full_name);
    navigate(`/mentor/${slug}`);
  };

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    '@id': `${url}#webpage`,
    name: 'Mentorship Program',
    url,
    isPartOf: { '@id': `${site}/#website` },
    about: { '@id': `${site}/#organization` },
  };

  const mentorData = {
    hero: {
      eyebrow: 'MENTORSHIP PROGRAM',
      headline: 'Mentorship Program',
      subheadline: 'Connect with experienced mentors who guide you through your professional development journey.',
    },
    story: {
      pull_quote: 'The best professionals are built through a combination of technical knowledge, hands-on experience, and guidance from those who have walked the path before them.',
      paragraphs: [
        'Our mentorship program connects aspiring professionals with experienced mentors who have decades of field experience. We believe that the most effective way to develop competence is through a structured program that combines theoretical learning with practical, real-world application.',
        'The program is designed to bridge the gap between learning and field readiness, ensuring that participants develop not only technical knowledge but also the professional judgment and confidence needed to excel.',
        'Mentors in our program are industry experts with extensive international experience across a range of projects. They bring practical insights, real-world case studies, and industry connections that accelerate professional development.'
      ],
    },
    cta: {
      headline: 'Ready to Start Your Mentorship Journey?',
      subheadline: 'Connect with our expert mentors and accelerate your career growth.',
      cta_primary: 'Apply Now',
      cta_secondary: 'Learn More'
    }
  };

  return (
    <>
      <Helmet>
        <title>Mentorship Program</title>
        <meta name="description" content="Connect with experienced mentors who guide you through your professional development journey." />
        <link rel="canonical" href={url} />
        <meta property="og:title" content="Mentorship Program" />
        <meta property="og:description" content="Expert mentorship for aspiring professionals. Build your career with guidance from certified professionals." />
        <meta property="og:url" content={url} />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      </Helmet>

      <Navbar />

      <main>
        {/* ── HERO ── */}
        <section className="mentor-hero">
          <div className="mentor-hero-top-line" />
          <div className="mentor-hero-grid-overlay" />
          <div className="container">
            <motion.div
              initial={{ opacity: 0, y: 32 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: 'easeOut' }}
              className="mentor-hero-content"
            >
              <div className="mentor-hero-eyebrow">
                <div className="mentor-hero-line" />
                <span>{mentorData.hero.eyebrow}</span>
              </div>
              <h1 className="mentor-hero-title">{mentorData.hero.headline}</h1>
              <p className="mentor-hero-subtitle">{mentorData.hero.subheadline}</p>
            </motion.div>
          </div>
        </section>

        {/* ── STORY ── */}
        <section className="mentor-story-section">
          <div className="container">
            <div className="mentor-story-grid">
              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={stagger}
                className="mentor-story-quote"
              >
                <motion.div variants={fadeUp} className="mentor-story-eyebrow">
                  <div className="mentor-hero-line" />
                  <span>Why Mentorship Matters</span>
                </motion.div>
                <motion.blockquote variants={fadeUp} className="mentor-story-blockquote">
                  <span className="mentor-story-quote-mark">"</span>
                  <p className="mentor-story-quote-text">
                    {mentorData.story.pull_quote}
                  </p>
                </motion.blockquote>
              </motion.div>

              <motion.div
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                variants={stagger}
                className="mentor-story-paragraphs"
              >
                {mentorData.story.paragraphs.map((para, i) => (
                  <motion.p key={i} variants={fadeUp} className="mentor-story-text">
                    {para}
                  </motion.p>
                ))}
              </motion.div>
            </div>
          </div>
        </section>

        {/* ── MENTORS SECTION ── */}
        <section className="mentors-section">
          <div className="container">
            <FadeUp className="mentors-header">
              <div className="mentors-eyebrow">
                <div className="mentor-hero-line" />
                <span>Our Mentors</span>
                <div className="mentor-hero-line" />
              </div>
              <h2>Meet Our Expert Mentors</h2>
              <p>Connect with experienced professionals who are passionate about guiding the next generation.</p>
            </FadeUp>

            {loading ? (
              <div className="mentors-loading">
                <div className="mentors-loading-spinner"></div>
                <p>Loading mentors...</p>
              </div>
            ) : error ? (
              <div className="mentors-error">
                <p>{error}</p>
              </div>
            ) : mentors.length === 0 ? (
              <div className="mentors-empty">
                <p>No active mentors available at the moment. Please check back later.</p>
              </div>
            ) : (
              <div className="mentors-list">
                {mentors.map((mentor, index) => {
                  const imageUrl = getImageUrl(mentor.profile_picture);
                  return (
                    <FadeUp key={mentor.id} delay={index * 0.05}>
                      <div className="mentor-card-horizontal">
                        {/* Profile Section - 30% */}
                        <div className="mentor-card-profile">
                          <div className="mentor-avatar-large">
                            {imageUrl ? (
                              <img 
                                src={imageUrl} 
                                alt={mentor.full_name}
                                onError={(e) => {
                                  e.target.style.display = 'none';
                                  e.target.parentElement.innerHTML = `
                                    <div class="mentor-avatar-placeholder-large">
                                      ${mentor.full_name?.charAt(0) || 'M'}
                                    </div>
                                  `;
                                }}
                              />
                            ) : (
                              <div className="mentor-avatar-placeholder-large">
                                {mentor.full_name?.charAt(0) || 'M'}
                              </div>
                            )}
                          </div>
                          <div className="mentor-profile-badge">
                            <BadgeCheck size={14} />
                            <span>Verified Mentor</span>
                          </div>
                          <div className="mentor-profile-status">
                            <span className="status-dot active"></span>
                            Active
                          </div>
                          <div className="mentor-profile-stats">
                            <div className="profile-stat">
                              <Users size={14} />
                              <span>{mentor.current_trainees || 0}</span>
                            </div>
                            <div className="profile-stat">
                              <Star size={14} />
                              <span>{mentor.years_of_experience || 0}+ yrs</span>
                            </div>
                          </div>
                        </div>

                        {/* Details Section - 70% */}
                        <div className="mentor-card-details">
                          <div className="mentor-details-header">
                            <div>
                              <h3 className="mentor-name-large">{mentor.full_name}</h3>
                              <p className="mentor-title">{mentor.current_company || 'Independent Mentor'}</p>
                            </div>
                            <button 
                              onClick={() => handleViewProfile(mentor)}
                              className="mentor-view-btn"
                            >
                              View Profile <ArrowRight size={14} />
                            </button>
                          </div>

                          <div className="mentor-details-grid">
                            <div className="mentor-detail-item">
                              <Mail size={14} />
                              <span>{mentor.email}</span>
                            </div>
                            {mentor.phone_number && (
                              <div className="mentor-detail-item">
                                <Phone size={14} />
                                <span>{mentor.phone_number}</span>
                              </div>
                            )}
                            <div className="mentor-detail-item">
                              <Briefcase size={14} />
                              <span>{mentor.years_of_experience || 0} years experience</span>
                            </div>
                            <div className="mentor-detail-item">
                              <Users size={14} />
                              <span>Max {mentor.max_trainees || 'Unlimited'} trainees</span>
                            </div>
                          </div>

                          {mentor.specializations && mentor.specializations.length > 0 && (
                            <div className="mentor-specializations-section">
                              <span className="mentor-section-label">Specializations</span>
                              <div className="mentor-tags-list">
                                {mentor.specializations.map((spec, idx) => (
                                  <span key={idx} className="mentor-tag-item">
                                    {spec.department_name}
                                  </span>
                                ))}
                              </div>
                            </div>
                          )}

                          {mentor.certifications && mentor.certifications.length > 0 && (
                            <div className="mentor-certifications-section">
                              <span className="mentor-section-label">Certifications</span>
                              <div className="mentor-tags-list">
                                {mentor.certifications.slice(0, 4).map((cert, idx) => (
                                  <span key={idx} className="mentor-tag-item cert">
                                    {cert.certification_name || cert.certification_type_display}
                                  </span>
                                ))}
                                {mentor.certifications.length > 4 && (
                                  <span className="mentor-tag-item more">
                                    +{mentor.certifications.length - 4} more
                                  </span>
                                )}
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </FadeUp>
                  );
                })}
              </div>
            )}
          </div>
        </section>

        {/* ── CTA ── */}
        <section className="mentor-cta">
          <div className="mentor-cta-top-line" />
          <div className="container">
            <FadeUp>
              <div className="mentor-cta-content">
                <h2>{mentorData.cta.headline}</h2>
                <p>{mentorData.cta.subheadline}</p>
                <div className="mentor-cta-buttons">
                  <Link to="/contact" className="mentor-cta-primary">
                    {mentorData.cta.cta_primary} <ArrowRight size={16} />
                  </Link>
                  <Link to="/platform" className="mentor-cta-secondary">
                    {mentorData.cta.cta_secondary} <ChevronRight size={16} />
                  </Link>
                </div>
              </div>
            </FadeUp>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}